import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Spark } from "../components/Spark";
import { Wordmark } from "../components/Wordmark";

/** Centered card frame for invite / onboarding style pages (design system v2). */
export default function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="auth-v2 flex min-h-screen flex-col items-center justify-center bg-soft px-4 py-10">
      <div className="card w-full max-w-md p-6 shadow-soft-lg sm:p-8">
        <Link to="/" className="mb-6 inline-flex items-center gap-2.5" aria-label="VisaGenius home">
          <Spark size={32} tile="forest" />
          <Wordmark size={19} />
        </Link>
        {children}
      </div>
    </div>
  );
}
